import React, { useState, useContext, useEffect } from "react";
import { CombinedContext } from "../../../context/combinedContext";
import "./staffInfoModal.css";
import companyBasedRequest from "../../../request/companyBasedRequest";
import translations from "../../../translations/translations";

const StaffInfoModal = ({ open, onClose, staff, setStaff }) => {
    const { language, userData } = useContext(CombinedContext);

    const [local, setLocal] = useState({
        firstName: "",
        lastName: "",
        bio: "",
        image: "",
    });

    useEffect(() => {
        if (!staff) return;

        setLocal({
            firstName: staff.firstName || "",
            lastName: staff.lastName || "",
            bio: staff.bio || "",
            image: staff.image || "",
        });
    }, [staff]);

    if (!open) return null;

    const handleSave = async () => {
        const updateData = { ...local };

        // Update UI
        setStaff((prev) => ({ ...prev, ...updateData }));

        // Update backend
        try {
            await companyBasedRequest.updateStaffInfo(staff.userId, updateData, userData.cognitoTokens.AccessToken);
        } catch (err) {
            console.error("Failed to update staff info", err);
        }

        onClose();
    };

    return (
        <div className="sf-book-overlay" onClick={onClose}>
            <div className="sf-book-modal" onClick={(e) => e.stopPropagation()}>
                <div className="sf-profile-modal-header">
                    <h2>{translations[language].profile.staffInfo.title}</h2>{" "}
                    <button className="sf-book-close" onClick={onClose}>
                        ✕
                    </button>
                </div>

                <div className="sf-book-body">
                    <label>{translations[language].profile.staffInfo.firstName}</label>
                    <input
                        className="sf-book-input"
                        value={local.firstName}
                        onChange={(e) => setLocal({ ...local, firstName: e.target.value })}
                    />

                    <label>{translations[language].profile.staffInfo.lastName}</label>

                    <input
                        className="sf-book-input"
                        value={local.lastName}
                        onChange={(e) => setLocal({ ...local, lastName: e.target.value })}
                    />

                    <label>{translations[language].profile.staffInfo.bio}</label>
                    <textarea
                        className="sf-book-input"
                        value={local.bio}
                        onChange={(e) => setLocal({ ...local, bio: e.target.value })}
                    />
                </div>

                <div className="sf-book-footer">
                    <button className="sf-book-btn sf-book-btn--brand" onClick={handleSave}>
                        {translations[language].profile.actions.saveChanges}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StaffInfoModal;
